export default "__VITE_PUBLIC_ASSET__66aea5a4__"